export default "__VITE_ASSET__DWHO8gSe__"